import React, { useState } from 'react';
import { Table, Button, Space, message, Modal, Form, Input } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';

const { TextArea } = Input;

const FAQs = () => {
    const [faqs, setFaqs] = useState([
        {
            id: 1,
            question: 'How do I book a service?',
            answer: 'You can book a service by selecting the service you need and filling out the booking form...',
            updatedAt: '2025-01-15',
        },
        {
            id: 2,
            question: 'What payment methods do you accept?',
            answer: 'We accept all major credit cards, debit cards, and digital payment methods...',
            updatedAt: '2025-01-10',
        },
        {
            id: 3,
            question: 'Can I cancel my booking?',
            answer: 'Yes, you can cancel your booking up to 24 hours before the scheduled time...',
            updatedAt: '2025-01-08',
        },
    ]);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingFaq, setEditingFaq] = useState(null);
    const [form] = Form.useForm();

    const handleAddFaq = () => {
        setEditingFaq(null);
        setIsModalVisible(true);
        form.resetFields();
    };

    const handleEditFaq = (record) => {
        setEditingFaq(record);
        setIsModalVisible(true);
        form.setFieldsValue({
            question: record.question,
            answer: record.answer,
        });
    };

    const handleDeleteFaq = (id) => {
        setFaqs(faqs.filter(faq => faq.id !== id));
        message.success('FAQ deleted successfully');
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
        setEditingFaq(null);
        form.resetFields();
    };

    const handleModalOk = async () => {
        try {
            const values = await form.validateFields();

            if (editingFaq) {
                // Update existing FAQ
                setFaqs(faqs.map(faq =>
                    faq.id === editingFaq.id
                        ? {
                            ...faq,
                            question: values.question,
                            answer: values.answer,
                            updatedAt: new Date().toISOString().split('T')[0],
                        }
                        : faq
                ));
                message.success('FAQ updated successfully');
            } else {
                // Add new FAQ
                const newFaq = {
                    id: faqs.length > 0 ? Math.max(...faqs.map(f => f.id)) + 1 : 1,
                    question: values.question,
                    answer: values.answer,
                    updatedAt: new Date().toISOString().split('T')[0],
                };
                setFaqs([...faqs, newFaq]);
                message.success('FAQ added successfully');
            }

            setIsModalVisible(false);
            setEditingFaq(null);
            form.resetFields();
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: 'Question',
            dataIndex: 'question',
            key: 'question',
        },
        {
            title: 'Answer',
            dataIndex: 'answer',
            key: 'answer',
            ellipsis: true,
            render: (text) => text.length > 100 ? `${text.substring(0, 100)}...` : text,
        },
        {
            title: 'Last Updated',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            width: 150,
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Button
                        icon={<EditOutlined />}
                        size="small"
                        onClick={() => handleEditFaq(record)}
                    >
                        Edit
                    </Button>
                    <Popconfirm
                        title="Are you sure you want to delete this FAQ?"
                        onConfirm={() => handleDeleteFaq(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button
                            icon={<DeleteOutlined />}
                            size="small"
                            danger
                        >
                            Delete
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>FAQs</h1>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleAddFaq}
                >
                    Add New FAQ
                </Button>
            </div>
            <Table
                columns={columns}
                dataSource={faqs}
                rowKey="id"
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total) => `Total ${total} FAQs`,
                }}
            />

            <Modal
                title={editingFaq ? "Edit FAQ" : "Add New FAQ"}
                open={isModalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
                okText={editingFaq ? "Update FAQ" : "Add FAQ"}
                cancelText="Cancel"
                width={700}
            >
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item
                        label="Question"
                        name="question"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter FAQ question!',
                            },
                        ]}
                    >
                        <Input placeholder="Enter FAQ question" />
                    </Form.Item>

                    <Form.Item
                        label="Answer"
                        name="answer"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter FAQ answer!',
                            },
                        ]}
                    >
                        <TextArea
                            rows={6}
                            placeholder="Enter FAQ answer"
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default FAQs;

